import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {Col, FormGroup, Label, Row} from "reactstrap";
import {request} from "../../helper/APIUtils";
import {showBaro} from "../../helper/permission";
import {VirtualHost} from "../../constants";
import {showAxiosError} from "../../helper/helper";
import Alert from "react-s-alert";
import SelectMulti from "./SelectMulti";

class ReportSettingModal extends Component {

    constructor(props) {
        super(props);
        this.state ={
            defaultExcelHeaderList:[],
            index:null,
            selectedHeader:null,
            selectedHeaderList: [],
            error:{},
            loading: false
        };
        this.getDefaultExcelHeaderList  = this.getDefaultExcelHeaderList.bind(this);
        this.saveClicked                = this.saveClicked.bind(this);
    }

    componentDidMount() {
        let self=this;
        self.getDefaultExcelHeaderList();
    }

    getDefaultExcelHeaderList(){
        let self = this;
        self.setState({ loading:true});
        request({
            url: `/excelXpath/getDefaultExcelHeaderList`,
            method: 'post',
            data: "getDefaultExcelHeaderList"
        }).then(response => {
            let data = response.data;
            let defaultExcelHeaderList = data.defaultExcelHeaderList;
            if(showBaro()) {
                defaultExcelHeaderList = defaultExcelHeaderList.filter(header => header.documentType === "SERBESTMESLEKMAKBUZ");
            } else if ("faturam24" === VirtualHost.conf.resourcePrefix) {
                defaultExcelHeaderList = defaultExcelHeaderList.filter(header => header.documentType === "EARSIV5BINOTUZBIN");
            }
            let vknTckns = data.vknTckns;
            vknTckns.push(self.props.vknTckn);

            let convertedDefaultExcelHeaderList = defaultExcelHeaderList.map((excelHeader) => ({
                value: excelHeader.recordId,
                label: excelHeader.name
            }))
            self.setState({defaultExcelHeaderList: convertedDefaultExcelHeaderList,vknTckns,loading:false});
        }).catch(error => {
            showAxiosError(error);
            self.setState({loading:false});
        });
    }
    saveClicked() {
        let self = this;
            request({
                url:"/customerDefaultExcelHeaderSetting/save",
                method: 'post',
                data: self.state.selectedHeaderList ? self.state.selectedHeaderList : []
            }).then(response => {
                    Alert.success(response.data, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 1000
                    });
                    self.setState({disableSaveButton: false});
                    self.props.toggle();
                }).catch(error => {
                self.setState({disableSaveButton: false});
                showAxiosError(error);
            });
    }


    render() {
        return (
            <DefaultModal
                isOpen={this.props.show}
                title={"Rapor Türleri Seçimi"}
                size="xl"
                confirmBtnText="Kaydet"
                onConfirm={this.saveClicked}
                onCancel={()=>this.props.toggle()}>
                <Col sm="12">
                        <Row>
                            <Col sm={12}>
                                <FormGroup row>
                                    <Label sm={10} for='selectedExcelHeader' style={{fontWeight:'bold'}}>Rapor Türü</Label>
                                    <Col sm={12}>
                                        <SelectMulti
                                            options={this.state.defaultExcelHeaderList}
                                            assignSelected={(list) =>  this.setState({ selectedHeaderList: list})}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                </Col>
            </DefaultModal>
        );
    }
}

export default ReportSettingModal;